import React from "react";

import { RichTextModule } from "components/RichTextModule";
import { ContentModuleBaseAttributes } from "utils/orm";

import styles from "./blockQuote.module.scss";

export interface BlockQuoteBlock extends ContentModuleBaseAttributes {
    attribution: string;
    blockquote: string;
}

export const BlockQuoteModule: React.FC<BlockQuoteBlock> = ({ blockquote, attribution }) => (
    <section className={styles.pullQuote}>
        <div className={`${styles.quoteMark}  ${styles.open}`}>“</div>
        <blockquote>
            <RichTextModule type="richTextBlock" richText={blockquote} />
        </blockquote>
        <div className={`${styles.quoteMark}  ${styles.close}`}>”</div>
        <footer>
            &#8212;&nbsp;
            <RichTextModule className={styles.richText} type="richTextBlock" richText={attribution} />
        </footer>
    </section>
);
